import React, { FC } from "react";
import { Radio as ARadio } from "@atlaskit/radio";

export const Radio: FC<any> = (props) => <ARadio {...props} />;
